// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ArchitectureComponent} from './Architecture.svg';

import Icon, { TIconProps } from '../Icon';

export const IconArchitecture = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ArchitectureComponent/>
  </Icon>
));
